import Node from 'ln/node/Node';
import Template from 'ln/template/TemplateManager';
import View from 'ln/view/View';
import List from 'ln/list/List';
import ListRenderer from 'ln/list/ListRenderer';
import BackendModel from 'ln/model/BackendModel';
import UserModel from '../course/models/UserModel';


class TagEditor extends View {

	private choices:string[];
	private userChoices:string[] = [];
	public tagListRenderer;

	private tagList;
	
	constructor( tagList:List<BackendModel>, template:string = 'krw.tag-editor' ) {
		super();
		this.tagList = tagList;
		this.choices = [];
		this.defaultTemplate = template;
	}

	public init() {

		this.tagListRenderer = new ListRenderer<BackendModel>( this.node.js( 'tags' ) );

		this.tagListRenderer.defaultRender( ( backendModel:BackendModel ) => {
			var node = Node.fromHTML( Template.render( 'krw.tag-editor-tag', backendModel ) );
			
			node.js( 'remove' ).click.add( ( node ) => {
				this.tagList.remove( backendModel );
				this.renderChoices();
			}, this );
			return { node: node };
		});
		
		this.tagListRenderer.source = this.tagList;
		this.node.js( 'add' ).click.add( this.onAddTag, this );
		this.renderChoices();
		this.node.js( 'guestuserinput' ).keyup.add( this.onGuestUserInput, this );
	}

	private onGuestUserInput( input:Node ){
		var filteredChoices = this.getFilteredChoices();

		if( input.value.length > 2 ){
			this.userChoices = filteredChoices.filter( ( choice:any ) => {
				var firstname = ( choice.firstname ) ? choice.firstname.toLowerCase() : ' ';
				var lastname = ( choice.lastname ) ? choice.lastname.toLowerCase() : ' ';

				var fullName = firstname + ' ' + lastname;
				return fullName.indexOf( input.value.toLowerCase() ) >= 0;
			});
		} else {
			this.userChoices = [];

		}
		this.renderChoices();

	}

	private onAddTag( node:Node ) {

		var selectList = this.node.one( 'select' );
		var nativeSelectList = selectList.native as any;
		if( nativeSelectList.selectedIndex == -1 ) return; // no selection was made
		var id = nativeSelectList.options[ nativeSelectList.selectedIndex ].value;
		var text = nativeSelectList.options[ nativeSelectList.selectedIndex ].text;
		var dataset = nativeSelectList.options[ nativeSelectList.selectedIndex ].dataset;
		var firstname = dataset.firstname;
		var lastname = dataset.lastname;
		var username = dataset.username;

		// reset userChoices
		this.userChoices = []

		// reset input
		this.node.js( 'guestuserinput' ).value = "";

		this.tagList.append( new UserModel( { modelName: 'App\\User', firstname: firstname, lastname: lastname, username: username, id: id }) );
		this.renderChoices();
	}

	private renderChoices() {
		var node = Node.fromHTML( Template.render( 'krw.tag-editor-choices', { choices: this.userChoices } ) );
		this.node.one( 'select' ).replace( node );
	}

	private getFilteredChoices(  ) {
		var filteredChoices = [];

		for( var i = 0; i < this.choices.length; i++ ) {
			
			// filter all existsing tags from the choices
			var found = this.tagList.items.some( function( item ) {
				return item.get( 'username' ) ==  this.choices[i].username;
			}, this);

			if( !found ) {
				filteredChoices.push( this.choices[i] );
			}
		}
		return filteredChoices;
	}

	public setChoices( choices:string[] ) {
		this.choices = choices;
	}

}

export default TagEditor;